import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "loader-wrapper"
};
import { useStore } from "@/store";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadingMask',
    setup: function (__props) {
        var store = useStore();
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_Transition, { name: "loading-fade" }, {
                default: _withCtx(function () { return [
                    (_unref(store).axiosConnections != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
                            _createElementVNode("div", { class: "loader" }, [
                                _createElementVNode("div", { class: "floating-image-container" }, [
                                    _createElementVNode("img", {
                                        src: "/img/loading1.png",
                                        class: "floating-image",
                                        alt: "loading"
                                    })
                                ]),
                                _createElementVNode("div", { class: "loader-ring" }, [
                                    _createElementVNode("div", { class: "loader-sector" }, "l"),
                                    _createElementVNode("div", { class: "loader-sector" }, "o"),
                                    _createElementVNode("div", { class: "loader-sector" }, "a"),
                                    _createElementVNode("div", { class: "loader-sector" }, "d"),
                                    _createElementVNode("div", { class: "loader-sector" }, "i"),
                                    _createElementVNode("div", { class: "loader-sector" }, "n"),
                                    _createElementVNode("div", { class: "loader-sector" }, "g"),
                                    _createElementVNode("div", { class: "loader-sector" }, "."),
                                    _createElementVNode("div", { class: "loader-sector" }, "."),
                                    _createElementVNode("div", { class: "loader-sector" }, "."),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" })
                                ]),
                                _createElementVNode("div", { class: "loader-ring" }, [
                                    _createElementVNode("div", { class: "loader-sector" }, "l"),
                                    _createElementVNode("div", { class: "loader-sector" }, "o"),
                                    _createElementVNode("div", { class: "loader-sector" }, "a"),
                                    _createElementVNode("div", { class: "loader-sector" }, "d"),
                                    _createElementVNode("div", { class: "loader-sector" }, "i"),
                                    _createElementVNode("div", { class: "loader-sector" }, "n"),
                                    _createElementVNode("div", { class: "loader-sector" }, "g"),
                                    _createElementVNode("div", { class: "loader-sector" }, "."),
                                    _createElementVNode("div", { class: "loader-sector" }, "."),
                                    _createElementVNode("div", { class: "loader-sector" }, "."),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" }),
                                    _createElementVNode("div", { class: "loader-sector" })
                                ])
                            ], -1)
                        ])))
                        : _createCommentVNode("", true)
                ]; }),
                _: 1
            }));
        };
    }
});
